import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import VisuallyHidden from '@s-ui/react-primitive-visually-hidden'
import ArrowDownMedium from '@adv-mt/mt-svg-icons/lib/ArrowDownMedium.js'
import {Icon, ICON_SIZES} from '@adv-mt/ui/icon'
import {Body2} from '@adv-mt/ui/typography'

const BASE_CLASS = 'mt-CardRelatedAdV2-priceDrop'

const CardRelatedAdV2PriceDrop = ({priceDropData}) => {
  const {i18n} = useContext(Context)

  const {originalPrice, percentage} = priceDropData || {}

  if (!priceDropData) return null

  const droppedPercentage = `${percentage * -1}%`

  return (
    <div className={BASE_CLASS}>
      <VisuallyHidden>{i18n.t('COMMON.PRICE_DROP.LABEL', {priceDrop: droppedPercentage})}</VisuallyHidden>
      <Body2 aria-hidden as="span" className={`${BASE_CLASS}Percentage`} highlight>
        <Icon size={ICON_SIZES.SM}>
          <ArrowDownMedium aria-hidden size={ICON_SIZES.SM} />
        </Icon>
        {droppedPercentage}
      </Body2>
      <Body2 as="s" className={`${BASE_CLASS}OriginalPrice`} highlight>
        {i18n.c(originalPrice)}
      </Body2>
    </div>
  )
}

CardRelatedAdV2PriceDrop.displayName = 'CardRelatedAdV2PriceDrop'

CardRelatedAdV2PriceDrop.propTypes = {
  priceDropData: PropTypes.shape({
    originalPrice: PropTypes.number,
    percentage: PropTypes.number
  })
}

export default CardRelatedAdV2PriceDrop
